import React from 'react';
import styles from './DeleteButton.module.scss'
import { Icon } from 'antd';

const DeleteButton = ({onClick}) => {
  return (
    <div className={styles.deleteButton} onClick={onClick}>
      <Icon type="close" />
    </div>
  );
};

export default DeleteButton;